import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IFilterParams, IOrdersListItem, IReportsList } from '../interfaces';

export class MonthlyUsageStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: MonthlyUsageStore;
    public static getInstance(): MonthlyUsageStore {
        if (!MonthlyUsageStore.instance) {
            MonthlyUsageStore.instance = new MonthlyUsageStore();
        }
        return MonthlyUsageStore.instance;
    }

    @observable list: IReportsList[] = [];
    @action setList(list: IReportsList[]): void {
        this.list = list;
    }

    @observable totals?: { [key: string]: string } = {};
    @action setTotal(totals: { [key: string]: string }): void {
        this.totals = totals;
    }

    @action cleanStore(): void {
        this.list = [];
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        pageNumber: false,
        pageSize: false,
        search: false,
        companyId: false,
    };
}
